<script>
import store from '@state/store'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import { validationMixin } from 'vuelidate'
import ProfileTab from '@router/components/profile-tab.vue'

export default {
  name: 'UserEdit',
  components: {
    Tab,
    Tabs,
    ProfileTab,
  },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      goals: this.user.my_goals
        ? JSON.parse(JSON.stringify(this.user.my_goals))
        : [],
    }
  },
  computed: {
    defaultCompany() {
      var found = false
      this.user.companies.forEach((company) => {
        if (this.user.default_company_id === company.id) {
          found = company
        }
      })
      return found
    },
    companies() {
      var companies = []
      this.user.companies.forEach((company) => {
        if (
          this.user.default_company_id !== company.id &&
          company.name !== 'My Hub' &&
          company.slug !== 'my-hub'
        ) {
          companies.push(company)
        }
      })
      return companies
    },
    volunteerGoal: {
      get: function() {
        var goal = 0
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'volunteered') {
            goal = this.goals[index].goal
          }
        }
        return goal
      },
      set: function(val) {
        this.$emit('input', val)
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'volunteered') {
            this.goals[index].goal = val
          }
        }
      },
    },
    donationGoal: {
      get: function() {
        var goal = 0
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'donation') {
            goal = this.goals[index].goal
          }
        }
        return goal
      },
      set: function(val) {
        this.$emit('input', val)
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'donation') {
            this.goals[index].goal = val
          }
        }
      },
    },
    kyndnessGoal: {
      get: function() {
        var goal = 0
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'kyndness') {
            goal = this.goals[index].goal
          }
        }
        return goal
      },
      set: function(val) {
        this.$emit('input', val)
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'kyndness') {
            this.goals[index].goal = val
          }
        }
      },
    },
    gratitudeGoal: {
      get: function() {
        var goal = 0
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'gratitude') {
            goal = this.goals[index].goal
          }
        }
        return goal
      },
      set: function(val) {
        this.$emit('input', val)
        for (let index = 0; index < this.goals.length; index++) {
          if (this.goals[index].type === 'gratitude') {
            this.goals[index].goal = val
          }
        }
      },
    },
    volunteerAchieved() {
      var achieved = 0
      for (let index = 0; index < this.goals.length; index++) {
        if (this.goals[index].type === 'volunteered') {
          achieved = this.goals[index].achieved
        }
      }
      return achieved
    },
    donationAchieved() {
      var achieved = 0
      for (let index = 0; index < this.goals.length; index++) {
        if (this.goals[index].type === 'donation') {
          achieved = this.goals[index].achieved
        }
      }
      return achieved
    },
    kyndnessAchieved() {
      var achieved = 0
      for (let index = 0; index < this.goals.length; index++) {
        if (this.goals[index].type === 'kyndness') {
          achieved = this.goals[index].achieved
        }
      }
      return achieved
    },
    gratitudeAchieved() {
      var achieved = 0
      for (let index = 0; index < this.goals.length; index++) {
        if (this.goals[index].type === 'gratitude') {
          achieved = this.goals[index].achieved
        }
      }
      return achieved
    },
  },
  methods: {
    saveUserGoals() {
      var goals = this.goals
      var data = {
        goals: JSON.stringify(goals),
      }
      store
        .dispatch('auth/updateUser', {
          data: data,
        })
        .then((response) => {
          this.editingName = false
        })
    },
    resetUserGoals() {},
    leaveHub(hubId) {
      store
        .dispatch('auth/leaveHub', {
          hubId: hubId,
        })
        .then((response) => {})
    },
    setHubAsDefault(companyId) {
      store
        .dispatch('auth/setDefaultCompany', {
          companyId: companyId,
        })
        .then((response) => {})
    },
    leaveOpenGroup(groupId) {
      store
        .dispatch('auth/leaveOpenGroup', {
          groupId: groupId,
        })
        .then((response) => {})
    },
    selectedTab() {
      if (this.$route.meta.tmp.showUserProfile) {
        return 1
      } else {
        return 0
      }
    },
    acceptInvite(invite) {
      store
        .dispatch('companies/acceptHubInvite', {
          requestId: invite.id,
        })
        .then((response) => {
          if (response.message === 'success') {
            store
              .dispatch('auth/acceptedHubInvite', {
                invite: invite,
              })
              .then((response) => {
                this.$router.push({
                  name: 'company',
                  params: { companyId: invite.company_id },
                })
              })
          }
        })
    },
    rejectInvite(invite) {
      store
        .dispatch('companies/rejectHubInvite', {
          requestId: invite.id,
        })
        .then((response) => {
          if (response.message === 'success') {
            store
              .dispatch('auth/rejectedHubInvite', {
                invite: invite,
              })
              .then((response) => {})
          }
        })
    },
  },
}
</script>

<template>
  <div>
    <h3 class="block pb-6 italic font-brandon text-blue-darker text-35xl"
      >EDIT USER</h3
    >
    <Tabs :active-tab="selectedTab()">
      <Tab
        title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21.044 24.049" class="inline-block align-middle"><g id="Group_244" data-name="Group 244" transform="translate(-453.062 -37.45)"><path id="Path_109" data-name="Path 109" d="M463.593,50.506a6.528,6.528,0,1,0-6.529-6.528A6.546,6.546,0,0,0,463.593,50.506Zm-5.133-6.528a5.139,5.139,0,0,1,5.133-5.133l.133,0a5.135,5.135,0,1,1-5.266,5.135Z" fill="#00638A"/><path id="Path_110" data-name="Path 110" d="M463.584,50.727a10.534,10.534,0,0,0-10.522,10.522v.25h1.4v-.25a9.139,9.139,0,0,1,9.123-9.123h0a9.126,9.126,0,0,1,9.127,9.123v.25h1.15v-.25h.24A10.534,10.534,0,0,0,463.584,50.727Z" fill="#00638A"/></g></svg> <span class="align-middle">Profile</span>'
      >
        <ProfileTab :user="user" :is-in-modal="true" />
      </Tab>
      <Tab
        title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 981.46" width="29" height="29" fill="#00638A" class="inline-block align-middle"><title>Kyndhub_Hubs_Icon</title><path d="M979.53,132.29a75.57,75.57,0,0,0-54-26.42,78.93,78.93,0,0,0-83.94,72h0A64.07,64.07,0,0,0,844,204.35L599.05,346a153.26,153.26,0,0,0-32.4-30,132.48,132.48,0,0,0-60-22.81V163.67a78.58,78.58,0,1,0-65.19-10.91h0a86.82,86.82,0,0,0,24,10.82V293.24A140.87,140.87,0,0,0,373,346.08L154.71,220a78.4,78.4,0,0,0-6-49.15,79.77,79.77,0,0,0-44.48-39.7,75,75,0,0,0-60,3.61,79.8,79.8,0,0,0-39.57,44.4,75,75,0,0,0,3.61,60,79.82,79.82,0,0,0,44.4,39.62,93.61,93.61,0,0,0,25.24,4.79,66.57,66.57,0,0,0,33.63-8.4,100,100,0,0,0,25.19-19.21l217.4,124.86a131.43,131.43,0,0,0-7.21,80.45,170.17,170.17,0,0,0,7.21,26.43L229.14,559.71A79,79,0,0,0,94.65,608.87a77.84,77.84,0,0,0,72.54,82.79l.71,0h5.94a80.67,80.67,0,0,0,51.61-19.21A75.6,75.6,0,0,0,252,618.37h0A66.13,66.13,0,0,0,249.54,592l125-71.89a153.06,153.06,0,0,0,32.41,30,135.81,135.81,0,0,0,60,22.81V837a78.17,78.17,0,0,0-44.41,31.22,80,80,0,0,0,20.49,109.25,74.23,74.23,0,0,0,44.4,13.19,76.33,76.33,0,0,0,64.85-34.82,80,80,0,0,0-20.48-109.25h0a86.88,86.88,0,0,0-24-10.82V571.72c2.42,0,4.79-1.19,7.21-1.19a144.33,144.33,0,0,0,85.25-51.62l162.09,93.65a77.84,77.84,0,0,0,49.16,94.83,93.33,93.33,0,0,0,25.19,4.79,66.7,66.7,0,0,0,33.64-8.39A79.86,79.86,0,0,0,910,659.38a75,75,0,0,0-3.61-60A79.82,79.82,0,0,0,862,559.75a75,75,0,0,0-60,3.61A71.08,71.08,0,0,0,780.32,579l-161-91.27a131.46,131.46,0,0,0,7.21-80.46,170.35,170.35,0,0,0-7.21-26.42L865.48,239.17A76,76,0,0,0,915.91,262h6a77.83,77.83,0,0,0,78-73.24A81.94,81.94,0,0,0,979.53,132.29ZM94.69,239.12A34.52,34.52,0,0,1,66,240.31,33.38,33.38,0,0,1,43,221a34.58,34.58,0,0,1-1.19-28.68,37.16,37.16,0,0,1,36-25.19,35.25,35.25,0,0,1,12,2.42,38.19,38.19,0,0,1,21.63,19.21,36.86,36.86,0,0,1-15.55,49.76c-.41.22-.83.43-1.25.63ZM211.16,617.31h0A42.93,42.93,0,0,1,198,643.73a38.94,38.94,0,0,1-27.61,9.59,43,43,0,0,1-26.42-13.19,39,39,0,0,1-9.58-27.61,38.22,38.22,0,0,1,38.42-36h2.42a42.92,42.92,0,0,1,26.42,13.19,35.73,35.73,0,0,1,9.55,27.65ZM454.85,66.25a38.84,38.84,0,1,1-.18.27ZM518.51,937.9a38.14,38.14,0,0,1-63.62-42,35.66,35.66,0,0,1,24-15.61c2.42,0,4.79-1.19,7.21-1.19a36.05,36.05,0,0,1,21.63,7.21h0a35.64,35.64,0,0,1,12.62,48.8C519.79,936.05,519.17,937,518.51,937.9ZM505.32,535.67a102.8,102.8,0,0,1-76.85-15.61,100.06,100.06,0,0,1-43.26-66,102.83,102.83,0,0,1,15.61-76.85,106.08,106.08,0,0,1,85.25-45.6,102.08,102.08,0,0,1,57.64,18,100,100,0,0,1,43.21,66,102.79,102.79,0,0,1-15.6,76.85,109.45,109.45,0,0,1-66,43.18Zm314.57,66a38.31,38.31,0,0,1,16.79-3.6,35.54,35.54,0,0,1,12,2.41,38.18,38.18,0,0,1,21.63,19.22,34.56,34.56,0,0,1,1.18,28.67A38.19,38.19,0,0,1,852.29,670a34.56,34.56,0,0,1-28.67,1.19A38.13,38.13,0,0,1,802,652a34.58,34.58,0,0,1-1.19-28.68,37.74,37.74,0,0,1,19.05-21.59ZM959.17,186.28a38.51,38.51,0,1,1-76.94-3.3c0-.5,0-1,.09-1.49h0a38.71,38.71,0,0,1,41-36,43,43,0,0,1,26.43,13.19,32.77,32.77,0,0,1,9.42,27.65Z" transform="translate(0 -9.27)"/></svg> <span class="align-middle">Hubs</span>'
      >
        <div class="">
          <p class="mb-7">Here you can manage the hubs you belong to:</p>
          <div class="">
            <div v-if="defaultCompany" class="mb-2 text-blue-darker">
              Default Hub:
            </div>
            <div v-if="defaultCompany" class="mb-7">
              <div
                class="flex justify-between px-8 py-4 mb-2 -mx-8 bg-gray-lightest rounded-comments leading-125"
              >
                <router-link
                  :to="{
                    name: 'company',
                    params: { companyId: defaultCompany.id },
                  }"
                  class=""
                  ><img
                    :src="defaultCompany.image_url"
                    class="inline-block w-5 h-5 mr-2 rounded-full"
                  />
                  <span class="text-blue-darker">{{
                    defaultCompany.name
                  }}</span></router-link
                >
                <div class="flex text-sm text-blue">
                  <div
                    class="cursor-pointer"
                    @click="leaveHub(defaultCompany.id)"
                  >
                    <span class="ml-2">X</span> Leave Hub
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="user.company_invites.length > 0"
              class="mb-2 text-blue-darker"
            >
              Invites:
            </div>
            <div class="mb-7">
              <div
                v-for="invite in user.company_invites"
                :key="invite.id"
                class="flex justify-between px-8 py-4 mb-2 -mx-8 bg-gray-lightest rounded-comments leading-125"
              >
                <span>
                  <img
                    :src="invite.company.image_url"
                    class="inline-block w-5 h-5 mr-2 rounded-full"
                  />
                  <span class="text-blue-darker">{{
                    invite.company.name
                  }}</span>
                </span>
                <div class="flex text-sm text-blue">
                  <div class="cursor-pointer" @click="acceptInvite(invite)">
                    <div
                      class="w-5 h-5 leading-normal text-gray text-center ml-2 text-l border border-gray-dark rounded-full relative"
                      ><span
                        class="absolute left-0 mt-1 leading-3 text-center w-full"
                        >✓</span
                      ></div
                    >
                  </div>
                  <div class="cursor-pointer" @click="rejectInvite(invite)">
                    <div
                      class="w-5 h-5 leading-normal text-gray text-center ml-2 text-l border border-gray-dark rounded-full relative"
                      ><span
                        class="absolute left-0 mt-1 leading-3 text-center w-full"
                        >X</span
                      ></div
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-if="defaultCompany" class="mb-2 text-blue-darker">
              Secondary Hubs:
            </div>
            <div class="mb-2">
              <div
                v-for="company in companies"
                :key="company.id"
                class="flex justify-between px-8 py-4 mb-2 -mx-8 bg-gray-lightest rounded-comments leading-125"
              >
                <router-link
                  :to="{
                    name: 'company',
                    params: { companyId: company.id },
                  }"
                  class=""
                >
                  <img
                    :src="company.image_url"
                    class="inline-block w-5 h-5 mr-2 rounded-full"
                  />
                  <span class="text-blue-darker">{{ company.name }}</span>
                </router-link>
                <div class="flex">
                  <div class="flex text-sm text-blue">
                    <div
                      class="cursor-pointer"
                      @click="setHubAsDefault(company.id)"
                    >
                      <span class="ml-2"></span> Set As Default
                    </div>
                  </div>
                  <div class="flex text-sm text-blue">
                    <div
                      class="cursor-pointer"
                      @click="leaveHub(defaultCompany.id)"
                    >
                      <span class="ml-2">X</span> Leave Hub
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tab>
      <Tab
        title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 896.11 1000" width="28" height="31" fill="#00638A" class="inline-block align-middle"><title>Kyndhub_Groups_Icon</title><path d="M857.9,580l-5.49-1.27V421.27l5.53-1.23a114.68,114.68,0,0,0,90.11-112.48,116.12,116.12,0,0,0-201.2-79.43l-3.85,4.1L609.58,155.14l1.31-5.2a145.3,145.3,0,0,0,5.41-33.39,116.5,116.5,0,0,0-233-.11v.11a89.39,89.39,0,0,0,5.16,32.77l2.09,5.61-133.5,77.34-3.85-4.1A116,116,0,1,0,142,420l5.49,1.27V578.69L142,580A116,116,0,1,0,253.21,771.83l3.85-4.1,133.09,77.13-1.31,5.2a145.3,145.3,0,0,0-5.41,33.39,116.5,116.5,0,0,0,233,.11v-.11a89.39,89.39,0,0,0-5.16-32.77l-2.09-5.61,133.66-77.46,3.85,4.09A116,116,0,1,0,857.9,579.84ZM832.83,231.78a74.59,74.59,0,0,1,74.51,74.51v.16a75.59,75.59,0,0,1-74.51,74.23,74.51,74.51,0,0,1,0-149ZM501.36,43.43a74.51,74.51,0,0,1,0,149,73.72,73.72,0,0,1-74.51-72.94c0-.52,0-1,0-1.57A74.59,74.59,0,0,1,501.36,43.43ZM96.77,307.56a74.51,74.51,0,1,1,74.51,74.55H171A75.58,75.58,0,0,1,96.77,307.56Zm73.12,459.35a74.51,74.51,0,1,1,74.51-74.59,74.51,74.51,0,0,1-74.51,74.59h0ZM501.36,956.53a74.52,74.52,0,0,1,0-149,73.73,73.73,0,0,1,74.51,73c0,.52,0,1,0,1.57a74.6,74.6,0,0,1-74.51,74.55Zm215-264.21a82.16,82.16,0,0,0,5,30.93l2.5,5.77-134,77.71-3.85-4.1a115.31,115.31,0,0,0-162.94-6.52q-3.39,3.14-6.52,6.52l-3.85,4.1L279.67,729.59l1.31-5.16a134.55,134.55,0,0,0,5.41-32A116.61,116.61,0,0,0,196.27,580l-5.49-1.27V421.31l5.49-1.27a116.61,116.61,0,0,0,90.12-112.48,82.13,82.13,0,0,0-5-30.93l-2.5-5.77L413,193.27l3.85,4.1a115.31,115.31,0,0,0,162.94,6.52q3.39-3.13,6.52-6.52l3.86-4.1L723,270.41l-1.31,5.16a134.55,134.55,0,0,0-5.41,32A116.61,116.61,0,0,0,806.41,420l5.49,1.27V578.69L806.41,580A116.62,116.62,0,0,0,716.33,692.32Zm115.1,74.51a74.51,74.51,0,1,1,0-149h.25A75.57,75.57,0,0,1,906,692.32,74.6,74.6,0,0,1,831.43,767Z" transform="translate(-51.94 0)"/></svg> <span class="align-middle">Groups</span>'
      >
        <div class="">
          <p class="mb-7">Here you can manage the groups you belong to:</p>
          <div class="">
            <div class="mb-2">
              <div
                v-for="group in user.open_groups"
                :key="group.id"
                class="flex justify-between px-8 py-4 mb-2 -mx-8 bg-gray-lightest rounded-comments leading-125"
              >
                <router-link
                  :to="{
                    name: 'group',
                    params: {
                      companyId: group.company_id,
                      groupId: group.id,
                    },
                  }"
                  class=""
                >
                  <img
                    :src="group.image_url"
                    class="inline-block w-5 h-5 mr-2 rounded-full"
                  />
                  <span class="text-blue-darker">{{ group.name }}</span>
                </router-link>
                <div class="flex text-sm text-blue">
                  <div class="cursor-pointer" @click="leaveOpenGroup(group.id)">
                    <span class="ml-2">X</span> Leave Group
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tab>
      <Tab
        title='<svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 24.861 25.805" fill="#069BD7" class="inline-block align-middle"><path id="Path_129" data-name="Path 129" d="M38.27,10.678l-12.545.031V7.5H13.41V33.305H14.5V20.224H24.636v2.925H38.271l-3.842-6.236ZM24.636,19.135H14.5V8.589H24.636ZM36.3,22.059H25.725V11.8H36.306l-3.172,5.117Z" transform="translate(-13.41 -7.5)" fill="#069BD7"/></svg> <span class="align-middle">Update Goals</span>'
      >
        <div class="">
          <p class="mb-7">My Kyndfulness Goals:</p>
          <div class="flex justify-between">
            <div class="w-7/12 mr-6">
              <div class="mb-5 text-blue-darker">
                Set Your Goals For The Year
              </div>
              <div
                class="rounded-2xl bg-blue-default text-sml text-white flex justify-between px-3.5 py-2.5 leading-looser mb-5 mr-6"
              >
                <span class="italic font-brandon">HOURS:</span>
                <input
                  v-model="volunteerGoal"
                  type="text"
                  class="w-5/12 bg-white input leading-paragraph"
                />
              </div>
              <div
                class="rounded-2xl bg-blue-default text-sml text-white flex justify-between px-3.5 py-2.5 leading-looser mb-5 mr-6"
              >
                <span class="italic font-brandon">ACTS OF KYNDNESS:</span>
                <input
                  v-model="kyndnessGoal"
                  type="text"
                  class="w-5/12 bg-white input leading-paragraph"
                />
              </div>
              <div
                class="rounded-2xl bg-blue-default text-sml text-white flex justify-between px-3.5 py-2.5 leading-looser mb-5 mr-6"
              >
                <span class="italic font-brandon">DONATION:</span>
                <input
                  v-model="donationGoal"
                  type="text"
                  class="w-5/12 bg-white input leading-paragraph"
                />
              </div>
              <div
                class="rounded-2xl bg-blue-default text-sml text-white flex justify-between px-3.5 py-2.5 leading-looser mb-5 mr-6"
              >
                <span class="italic font-brandon">GRATITUDE:</span>
                <input
                  v-model="gratitudeGoal"
                  type="text"
                  class="w-5/12 bg-white input leading-paragraph"
                />
              </div>
              <div class="">
                <button
                  class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                  @click="saveUserGoals"
                  >Save</button
                >
                <button
                  class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                  @click="resetUserGoals"
                  >Reset</button
                >
              </div>
            </div>
            <div class="w-1/2">
              <div class="mb-5 text-black">
                My Current Kyndfulness:
              </div>
              <div
                class="flex mt-5 h-13 border-l-5 border-volunteer_red leading-2xl"
              >
                <div class="pl-3.5 text-4xl text-blue-darker">
                  {{ volunteerAchieved }}
                </div>
                <div class="pl-3.5 text-basel text-blue-darker leading-16">
                  Volunteer Hours
                </div>
              </div>
              <div
                class="flex mt-5 h-13 border-l-5 border-aok_green leading-2xl"
              >
                <div class="pl-3.5 text-4xl text-blue-darker">
                  {{ kyndnessAchieved }}
                </div>
                <div class="pl-3.5 text-basel text-blue-darker leading-16">
                  Acts of Kyndness
                </div>
              </div>
              <div
                class="flex mt-5 h-13 border-l-5 border-donation leading-2xl"
              >
                <div class="pl-3.5 text-4xl text-blue-darker">
                  {{ donationAchieved }}
                </div>
                <div class="pl-3.5 text-basel text-blue-darker leading-16">
                  Donation
                </div>
              </div>
              <div
                class="flex mt-5 h-13 border-l-5 border-gratitude_purple leading-2xl"
              >
                <div class="pl-3.5 text-4xl text-blue-darker">
                  {{ gratitudeAchieved }}
                </div>
                <div class="pl-3.5 text-basel text-blue-darker leading-16">
                  Graditude
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tab>
    </Tabs>
  </div>
</template>
